const CLICKCOLLECT = 'CLICKCOLLECT';
const STANDARD = 'STANDARD';
const EXPRESS = 'EXPRESS';
const SAME_DAY = 'SAMEDAY';

export default {CLICKCOLLECT, STANDARD, EXPRESS, SAME_DAY}